module.exports = __webpack_public_path__ + "static/media/level1_q2_wrong.e8a4caa7.png";